export default __webpack_public_path__ + "static/fytJUvGZ-a521534839e26d5c1d86f385b4071100.svg";